
















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import axios from "axios";

@Component({})
export default class TechRequestChat extends Vue {
  @Prop({ default: false })
  isSelected!: boolean;
  @Prop({ default: '' })
  label!: string;
  @Prop({ default: '' })
  receiveMessageEventName!: string;
  @Prop({ default: '' })
  unreadMessagesCountEventName!: string;
  @Prop({ default: '' })
  iconClass!: string;

  messagesCount: number = 0;

  created() {
    this.$chatHub.unreadMessagesCount(this.currentUserId, this.unreadMessagesCountEventName);
    this.$chatHub.$on(
      this.receiveMessageEventName,
      this.onReceiveMessage
    );
    this.$chatHub.$on(
      this.unreadMessagesCountEventName,
      this.onUnreadMessagesCount
    );
  }

  beforeDestroy() {
    this.$chatHub.$off(
      this.receiveMessageEventName,
      this.onReceiveMessage
    );
    this.$chatHub.$off(
      this.unreadMessagesCountEventName,
      this.onUnreadMessagesCount
    );
  }

  onReceiveMessage(message: any) {
    if (message.toUserId == this.currentUserId) {
      this.$store.commit("chat/incrementUnreadMessagesCount");
      this.messagesCount++;
    }
  }

  @Watch("isSelected")
  onIsSelectedChanged(val: boolean) {
    if (val) {
      this.$store.commit(
        "chat/reduceUnreadMessagesCount",
        this.messagesCount
      );
      this.messagesCount = 0;
    }
  }

  onUnreadMessagesCount(unreadMessagesCount: any) {
    this.messagesCount = unreadMessagesCount;
  }

  get currentUserId() {
    return this.$auth.user().id;
  }
}
